import { render, staticRenderFns } from "./PurchaseInfoExtraFields.vue?vue&type=template&id=176c901d"
import script from "./PurchaseInfoExtraFields.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfoExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('176c901d')) {
      api.createRecord('176c901d', component.options)
    } else {
      api.reload('176c901d', component.options)
    }
    module.hot.accept("./PurchaseInfoExtraFields.vue?vue&type=template&id=176c901d", function () {
      api.rerender('176c901d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseInfoExtraFields.vue"
export default component.exports